export const KIND_LABEL = { feature: 'Feature', maintenance: 'Maintenance', hotfix: 'Hotfix' };

export const OUTCOME_COLORS = { success: '#4caf50', failed: '#f44336', skipped: '#bdbdbd', other: '#ff9800' };

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }) : '–';

export const formatDay = (iso) =>
  iso ? new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', timeZone: 'UTC' }) : '–';

export const formatPercent = (ratio, digits = 1) => (ratio == null ? '–' : `${(ratio * 100).toFixed(digits)}%`);

export const formatNumber = (n) => (n == null ? '–' : Number(n).toLocaleString('en-GB'));

export const formatDays = (n) => (n == null ? '–' : `${n} d`);

export const formatMinutes = (n) => (n == null ? '–' : `${n} min`);

export const compareVersionStrings = (a, b) => {
  const pa = String(a).split('-')[0].split('.').map(Number);
  const pb = String(b).split('-')[0].split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const diff = (pa[i] || 0) - (pb[i] || 0);
    if (diff) return diff;
  }
  return 0;
};

/** Gate wording is deliberately neutral so the same labels read well to customers and to management. */
export const GATE_LABEL = {
  tested: { go: 'Passed', caution: 'Minor gaps', hold: 'Gaps open', pending: 'In progress', na: 'No evidence' },
  approved: { go: 'Approved', caution: 'Conditional', hold: 'On hold', na: 'Not recorded' },
  rolledOut: { go: 'Healthy', caution: 'Watch', hold: 'Issues', pending: 'Not yet', na: 'No data' }
};
export const GATE_TITLE = { tested: 'Tested', approved: 'Approved', rolledOut: 'Rolled out' };
export const GATE_COLOR = { go: '#2e7d32', caution: '#c85a00', hold: '#c62828', pending: '#5f7d8c', na: '#9e9e9e' };

/** Same bands as the server's test verdict so the heatmap and the gate always agree. */
export const areaGrade = (cell) => {
  if (!cell || cell.passed + cell.failed === 0) return 'na';
  if (cell.executedPassRate >= 0.98 && cell.coverage >= 0.95) return 'go';
  if (cell.executedPassRate >= 0.95 && cell.coverage >= 0.85) return 'caution';
  return 'hold';
};

export const VERDICT_LABEL ={ go: 'Go', caution: 'Caution', hold: 'Hold', na: 'Not graded', insufficient: 'Not enough data' };
export const VERDICT_COLOR = { go: '#2e7d32', caution: '#c85a00', hold: '#c62828', na: '#757575', insufficient: '#757575' };
